module.exports = __webpack_public_path__ + "static/media/tabela.78832ab0.png";